<template>
    <div class="us_app">
        <section class="user_section">
            <article class="view cmnity">
                <div class="cmnity_detail">
                    <div class="title_box">
                        <h3>
                            {{ resourceInfo.title }}
                        </h3>
                        <div class="info_box">
                            <div class="info-left">
                                <p>작성일 <span>{{ resourceInfo.reg_dt }}</span></p>
                            </div>
                        </div>
                    </div>

                    <div class="resource-content" :class="{ 'is-image-only': isImageOnlyContent }" v-html="resourceInfo.content"></div>

                    <div class="file_area" v-if="resourceInfo.file_org_name">
                        <span class="file-label">첨부파일</span>
                        <a href="#" class="file-link" @click.prevent="fn_download_file(resourceInfo.file_id)">
                            <i class="icon icon_clip"></i>
                            {{ resourceInfo.file_org_name }}
                        </a>
                    </div>

                    <div class="bottom_box">
                        <button class="btn btn_md btn_darkbrown" @click="$router.push('/resource')">목록</button>
                    </div>
                </div>
            </article>
        </section>
    </div>
</template>

<script>
import axios from 'axios'
import commonUtil from '@/mixin/commonUtil'

export default {
    name: 'ResourceDetail',
    mixins: [commonUtil],
    data() {
        return {
            resourceId : '',
            resourceInfo: {}
        }
    },
    computed: {
        isImageOnlyContent() {
            const cnts = this.resourceInfo.content || '';
            if (!cnts) return false;

            const hasBase64Image = /<img[^>]+src=["']data:image\//i.test(cnts);
            const textOnly = cnts.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim();

            return hasBase64Image && textOnly === '';
        }
    },
    created(){
      this.resourceId = this.$store.getters['detailSearchInfo/getSearchId'];
      console.log("@@@@@ resourceId : %o", this.resourceId);
    },
    mounted() {
        this.fn_search()
    },
    methods: {
        fn_search() {

          let param = new Object();
          param.resourceId = this.resourceId;

          console.log("@@@@ param : %o", param);

            axios
                .post('/api/user/board/getResourceDetail', param)
                .then((res) => {
                    this.resourceInfo = res.data.resourceInfo
                })
                .catch((err) => console.log(err))
        }
    }
}
</script>

<style scoped>
/* 메타 정보 영역 */
.info_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0 0;
    border-top: 1px solid #e0e0e0;
}

.info-left {
    display: flex;
    gap: 20px;
}

.info-left p {
    font-size: 1.4rem;
    color: #666;
    font-weight: 600;
    margin: 0;
}

.info-left p span {
    font-size: 1.4rem;
    color: #333;
    font-weight: 400;
    margin-left: 4px;
}

/* 본문 박스 */
.resource-content {
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: #fafafa;
    padding: 24px 28px;
    min-height: 200px;
    margin: 20px 0 24px;
    line-height: 1.9;
    font-size: 1.4rem;
    color: #333;
    word-break: break-word;
}

.resource-content >>> img {
    max-width: 100%;
    height: auto;
}

.resource-content.is-image-only {
    text-align: center;
}

/* 첨부파일 영역 */
.file_area {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 13px 18px;
    border: 1px solid #c9daf8;
    border-radius: 8px;
    background-color: #eef3fc;
    margin-bottom: 24px;
}

.file-label {
    font-size: 1.3rem;
    font-weight: 700;
    color: #3d5a99;
    white-space: nowrap;
}

.file-link {
    font-size: 1.3rem;
    color: #3d5a99;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 6px;
}

.file-link:hover {
    text-decoration: underline;
    color: #1e3a70;
}
</style>